import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ChangeBoardingSingleSpotlight = withAsync({
	loader: lazyForPaint(
		() =>
			import(
				/* webpackChunkName: "change-boarding-single-spotlight" */ './change-boarding-single-spotlight'
			),
	),
	LoadingSkeleton: () => null,
});

export type { Props } from './change-boarding-single-spotlight';
